// Meta (Facebook) Pixel - ładowany warunkowo, dopiero po zgodzie marketingowej.
// SSR-bezpieczny: odwołania do window/document są w funkcjach wywoływanych tylko
// w przeglądarce (nigdy podczas builda/SSR).
// UWAGA: świadomie BEZ <noscript> - fallbacku bez JS nie da się zgejtować zgodą,
// a Meta Pixel to tracker marketingowy (RODO). Gejtujemy tak samo jak OpenAI.

const PIXEL_ID = "2195325930717082";

// Wstrzykuje SDK, inicjalizuje pixel i wysyła PageView. Idempotentne (guard w.fbq).
export const loadMetaPixel = () => {
  if (typeof window === "undefined") return;
  if (window.fbq) return; // już załadowany - nie dubluj
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );
  /* eslint-enable */

  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
};

// Konwersja Lead - moment wysłania danych kontaktowych + zgody + startu raportu.
// No-op, jeśli pixel nie jest załadowany (brak zgody marketingowej).
export const fireMetaLead = () => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "Lead");
  }
};
